import React from 'react'
import { Input, Button } from 'antd'
import { fromNullable } from 'data.maybe'

class AppRow extends React.Component {
  constructor(props) {
    super(props)
    this.dataChanged = this.dataChanged.bind(this)
    this.saveData = this.saveData.bind(this)
    this.cancelEdit = this.cancelEdit.bind(this)
    this.state = {
      edited: false,
      jwt: props.jwt,
      baseUrl: props.baseUrl,
    }
  }

  cancelEdit() {
    this.setState({
      edited: false,
      jwt: this.props.jwt,
      baseUrl: this.props.baseUrl,
    })
  }

  dataChanged(e) {
    const { name, value } = e.target
    this.setState({ [name]: value, edited: true })
  }

  componentDidUpdate(prevProps) {
    /* eslint-disable react/no-did-update-set-state */
    if (prevProps !== this.props) this.setState({ edited: false })
    /* eslint-enable react/no-did-update-set-state */
  }

  saveData() {
    const { baseUrl, jwt } = this.state
    const { appName, save } = this.props
    save &&
      save({
        appName,
        baseUrl,
        jwt: jwt && jwt.trim().length === 0 ? undefined : jwt,
      })
  }

  render() {
    const { Row, CellWrapper, dataWidth, appName } = this.props

    const { baseUrl, jwt, edited } = this.state
    return (
      <Row>
        <CellWrapper>{appName}</CellWrapper>
        <CellWrapper width={dataWidth}>
          <Input
            name="baseUrl"
            style={{ width: '100%' }}
            value={baseUrl}
            onChange={this.dataChanged}
          />
        </CellWrapper>
        <CellWrapper grow="1" width={dataWidth}>
          <Input
            name="jwt"
            fluid
            value={fromNullable(jwt).getOrElse('')}
            onChange={this.dataChanged}
          />
        </CellWrapper>
        {edited && (
          <CellWrapper width="250px">
            <Button type="primary" onClick={this.saveData}>
              Save
            </Button>
            <Button
              onClick={this.cancelEdit}
              style={{
                marginLeft: '10px',
                backgroundColor: 'black',
                color: 'white',
              }}
            >
              Cancel
            </Button>
          </CellWrapper>
        )}
      </Row>
    )
  }
}
export default AppRow
